module.exports = __webpack_public_path__ + "img/APP.9bf158d0.png";